module.exports = __webpack_public_path__ + "static/pit_fiend-f2bade02671437a0fcf71051c34fe50f.jpg";